module.exports = __webpack_public_path__ + "static/media/story-1.3b0e5697.jpeg";